import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { PipesModule } from '../shared/pipes/pipes.module';
import { UtilService } from '../shared/services/util.service';
import { FinalReportPage } from './final-report.page';
import { FinalReportService } from './final-report.service';
import { Evaluation360ReportModule } from '../shared/components/full-reports/360-evaluation/360-evaluation-report.module';
import { FreeEvaluationReportModule } from '../shared/components/full-reports/free-evaluation/free-evaluation-report.module';
import { CoachingReportModule } from '../shared/components/full-reports/coaching/coaching-report.module';
import {
  SelfManagerEvaluationReportModule
} from '../shared/components/full-reports/self-manager-evaluation/self-manager-evaluation.module';

const routes: Routes = [{
  path: '',
  component: FinalReportPage
}];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    PipesModule,
    Evaluation360ReportModule,
    FreeEvaluationReportModule,
    CoachingReportModule,
    SelfManagerEvaluationReportModule
  ],
  declarations: [
    FinalReportPage
  ],
  providers: [
    FinalReportService,
    UtilService
  ]
})
export class FinalReportModule { }
